import { Link } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';
import Breadcrumb from '../../../../components/layout/Breadcrumb';

// ===== EN Related / THE BUTLER — full redesign (mirrors JA; _shared dropped). External URL unchanged. Own FAQ. =====

const services = [
  { title: 'Housekeeping', en: 'Housekeeping', desc: 'Home management, cooking, laundry, shopping, and childcare support to quietly maintain the foundations of daily life.', img: '/images/generated/jba-still-hatship-01.jpg', alt: 'A display shelf with a top hat and a sailing-ship model' },
  { title: 'Business support', en: 'Business Support', desc: 'Schedule management, document preparation, meeting arrangements, and transport to support busy business days.', img: '/images/generated/jba-fs-198-related_the-butler-v8.jpg', alt: 'A butler supporting busy business days with secretarial work' },
  { title: 'Events & reception', en: 'Events & Reception', desc: 'Welcoming and seeing off guests, table service, and space production for hospitality on special days.', img: '/images/generated/jba-fs-199-related_the-butler-v8.jpg', alt: 'A butler welcoming guests for hospitality on a special day' },
  { title: 'Butler concierge', en: 'Butler Concierge', desc: 'Made-to-order services designed for VVIP and affluent clients.', img: '/images/generated/jba-fs-200-related_the-butler.jpg', alt: 'Made-to-order butler service designed for VVIP clients' },
];

const faqs = [
  {
    q: 'What is THE BUTLER?',
    a: 'THE BUTLER is a butler service operated by the Japan Butler Association. It combines the discipline and dignity of the English butler with the attentive courtesy unique to Japan, offering a fully made-to-order style of hospitality.',
  },
  {
    q: 'What can I request?',
    a: 'From housekeeping and business support such as schedule management, to guest reception, event service, and butler concierge care for VVIP clients, it supports daily life and hospitality comprehensively. Rather than simple housework, it creates an environment where you can focus on work, family, and rest.',
  },
  {
    q: 'How is it related to the Association and the Academy?',
    a: 'THE BUTLER and Japan Butler Academy are both based within the Japan Butler Association. THE BUTLER is one of the settings where butlers trained by the Academy deliver dignified service. Consultations and applications are handled through the official site, thebutler.jp.',
  },
];

const otherRelated = [
  { name: 'Japan Butler Academy', role: 'Training institution', to: '/en/related/butler-academy' },
  { name: 'Butler Bell', role: 'Media brand', to: '/en/related/butler-bell' },
];

const breadcrumbs = [
  { label: 'Home', href: '/en/' },
  { label: 'Related Sites', href: '/en/related' },
  { label: 'THE BUTLER' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.06em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function EnRelatedTheButlerPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/generated/jba-fs-201-related_the-butler-v8.jpg" alt="A butler in formal attire welcoming guests in an elegant salon, embodying THE BUTLER's comprehensive hospitality" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[700px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">THE BUTLER</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.02em] mb-6">
              Comprehensive hospitality, by a butler
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.9]">
              A butler hospitality service operated by the Japan Butler Association. Consultations and applications are handled through the official THE BUTLER site.
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* I. About */}
      <NavyBand no="I" ja="What is THE BUTLER?" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.01em] mb-5">
                Not outsourced housework, but <span className="text-[#a38e65]">the freedom to focus</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9] mb-4">
                THE BUTLER is a butler service operated by the Japan Butler Association, which is also the operating body of Japan Butler Academy. It combines the discipline and dignity of the English butler with the attentive courtesy unique to Japan, offering fully made-to-order hospitality.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9]">
                Rather than simply outsourcing housework, it values creating the very environment in which clients can focus on the work, family, and rest that truly matter. Sensing a need before it is spoken and quietly attending to it is the essence of THE BUTLER service.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-p-028-rel-residence.jpg" alt="A butler serving in a luxury residence" className="w-full h-[300px] sm:h-[400px] md:h-[460px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* II. Services */}
      <NavyBand no="II" ja="Main services" en="Services" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mb-10 text-left">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.01em] mb-5">
              Daily life and hospitality, <span className="text-[#a38e65]">across four areas</span>
            </h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.9]">
              From housekeeping and business support to event reception and butler concierge care for VVIP clients — from the everyday to the special occasion, THE BUTLER supports daily life and hospitality comprehensively.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {services.map((s, i) => (
              <article key={s.title} className="flex flex-col sm:flex-row border border-[#e2ddd2] overflow-hidden group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative sm:w-[42%] shrink-0 h-48 sm:h-auto min-h-[180px]">
                  <img src={s.img} alt={s.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                  <span className="absolute top-3 left-3 font-['Playfair_Display',serif] text-[#f8f6f0] text-2xl drop-shadow-lg">{String(i + 1).padStart(2, '0')}</span>
                </div>
                <div className="p-6 sm:p-7 flex flex-col justify-center text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1.5">{s.en}</span>
                  <h4 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-3 leading-[1.4]">{s.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{s.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* III. Relationship */}
      <NavyBand no="III" ja="Connection with the Association" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/generated/jba-p-029-rel-service-w2.jpg" alt="Butlers trained by the Academy delivering dignified service in the field" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.01em] mb-6">
                Learning and practice, <span className="text-[#d7b779]">under one Association</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9] mb-4">
                THE BUTLER is a butler service operated by the Japan Butler Association. It is one of the settings where butlers trained by Japan Butler Academy deliver dignified service.
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.9]">
                The fact that learning and practice are connected under the same Association means its education is not merely theoretical, but designed with real service settings in mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IV. Official Site */}
      <NavyBand no="IV" ja="Official site" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">THE BUTLER official site<span className="block text-lg text-[#8f7a56] mt-2 font-normal">Consultation and application</span></h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.9] max-w-2xl mx-auto mb-8">
              Consultations and applications for butler services are handled through the official THE BUTLER site, which also details plans and pricing.
            </p>
            <a href="https://thebutler.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              Visit the THE BUTLER official site <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* V. FAQ */}
      <NavyBand no="V" ja="Frequently asked questions" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.9] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other related + CTA */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">Other related sites</h3>
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">Interested in learning the butler craft?</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/en/qualifications" className={BTN08_ON_NAVY}>View certifications</Link>
              <Link to="/en/contact" className={BTN08_ON_NAVY}>Contact us</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
